<script setup>
import { Head, Link } from '@inertiajs/vue3';

defineProps({
    canLogin: {
        type: Boolean,
    },
});
</script>

<template>
    <Head title="Welcome" />
    <div class="flex min-h-screen items-center justify-center bg-primary-50 dark:bg-primary-950">
        <div class="w-full max-w-md space-y-8 rounded-lg bg-white p-8 shadow-lg dark:bg-primary-800">
            <div class="text-center">
                <img
                    src="/logo.png"
                    alt="4Record Logo"
                    class="mx-auto h-24 w-auto mb-4"
                />
                <h1 class="text-3xl font-bold text-primary-800 dark:text-primary-200">
                    4Record
                </h1>
                <p class="mt-2 text-muted">
                    Worksite management application
                </p>
            </div>

            <div class="text-center">
                <Link
                    href="/login"
                    class="inline-block w-full rounded-md bg-primary-600 px-4 py-2 text-center font-medium text-white transition hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:bg-primary-700 dark:hover:bg-primary-600"
                >
                    Log in
                </Link>
            </div>
        </div>
    </div>
</template>
